import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { Avatar, Badge, Color, Paragraph, Skeleton } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

function StatusText(props: { requiresInput: boolean; status: graphql.EvaluationSubmissionStatus }) {
	const { t } = useTranslation();

	if (props.requiresInput && props.status === graphql.EvaluationSubmissionStatus.Draft) {
		return <Paragraph>{t('evaluation.submission.status.draft')}</Paragraph>;
	}

	if (props.requiresInput && props.status === graphql.EvaluationSubmissionStatus.Shared) {
		return (
			<Paragraph>
				<Color color="green">{t('evaluation.submission.status.shared')}</Color>
			</Paragraph>
		);
	}

	if (
		!props.requiresInput &&
		(props.status === graphql.EvaluationSubmissionStatus.Draft ||
			props.status === graphql.EvaluationSubmissionStatus.Shared)
	) {
		return <Paragraph>{t('evaluation.submission.status.noInputRequired')}</Paragraph>;
	}

	if (props.status === graphql.EvaluationSubmissionStatus.Signed) {
		return (
			<Paragraph>
				<Color color="green">{t('evaluation.submission.status.signed')}</Color>
			</Paragraph>
		);
	}

	return null;
}

export default Skeleton(
	function ConversationParty(props: {
		result: graphql.EvaluationSubmissionResult;
		width?: number;
	}) {
		const badge =
			props.result.party === graphql.EvaluationSubmissionParty.Employee ? 'employee' : 'manager';

		return (
			<Flex alignItems="center" mr={2} width={props.width ?? 200}>
				<Badge.Container badge={<Badge color={badge} />} mr={2} flexGrow={0} flexShrink={0}>
					<Avatar size={32} user={props.result.user} />
				</Badge.Container>
				<Box flexGrow={1} flexShrink={1}>
					<Paragraph mb={1}>
						{props.result.user.firstName} {props.result.user.lastName}
					</Paragraph>
					<StatusText requiresInput={props.result.requiresInput} status={props.result.status} />
				</Box>
			</Flex>
		);
	},
	function ConversationPartySkeleton() {
		return (
			<Flex alignItems="center" mr={2} width={200}>
				<Avatar.Skeleton size={32} mr={2} flexGrow={0} flexShrink={0} />
				<Box flexGrow={1} flexShrink={1}>
					<Paragraph.Skeleton lines={1} mb={1} maxWidth={140} />
					<Paragraph.Skeleton lines={1} maxWidth={140} />
				</Box>
			</Flex>
		);
	},
);
